<div class="process-time-container">
  <div class="header">
    <div class="header-title">
      <pdq-heading element="h5">Extra processing time</pdq-heading>
      <pdq-tag mode="rect" [variant]="checkoutSettings?.processingTimeShippingIds?.length ? 'quaternary' : 'default'">
        {{ checkoutSettings?.processingTimeShippingIds?.length ? 'Active' : 'Inactive' }}</pdq-tag
      >
    </div>

    <pdq-button plain="true" variant="light" size="small" (click)="openProcessingTimeDialog()">Manage</pdq-button>
  </div>

  <div class="content">Add extra handling days to adjust delivery dates when your backlog is packed</div>
</div>
